import { makeStyles } from "@material-ui/core";

export const FormularioItemStyle = makeStyles((theme) => ({
  textField: {
    width: "97%",
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500,
  },
  textFieldMultiLinea: {
    width: "97%",
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500,
  },
  formControl: {
    width: "97%",
    margin: "5px",
  },
  containerSpacing: {
    margin: "10px 0",
  },
  modalBotones: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  modalBotonesCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalBoton: {
    margin: "1px 0",
    width: "20%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "900px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "none",
    boxShadow: theme.shadows[10],
    padding: theme.spacing(1, 2, 1),
    maxWidth: "900px",
    minWidth: "500px",
  },
}));
